import { createFileRoute } from "@tanstack/react-router";

import { AccountPage } from "../../features/account/AccountPage";
import { validateSectionSearch } from "../../features/account/sections";
import { useCheckoutBack, useCheckoutReturn, validateCheckoutSearch } from "../../features/billing/checkoutReturn";
import { useConnectionOutcome } from "../../features/instagram/outcome";
import { validateOutcomeSearch } from "../../features/instagram/outcomeSearch";

export const Route = createFileRoute("/_app/account")({
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateSectionSearch(search),
    ...validateOutcomeSearch(search),
    ...validateCheckoutSearch(search),
  }),
  component: function Account() {
    const search = Route.useSearch();
    return (
      <AccountPage
        section={search.section}
        outcome={useConnectionOutcome(search)}
        returned={useCheckoutReturn(search)}
        back={useCheckoutBack(search)}
      />
    );
  },
});
